module.exports = __webpack_public_path__ + "f2767d3cda7941d359dfe977cc9891c7.png";


//////////////////
// WEBPACK FOOTER
// ./app/images/hotline_footer.png
// module id = ./app/images/hotline_footer.png
// module chunks = 40